import { render } from "./ShipService.vue?vue&type=template&id=78091852&scoped=true"
import script from "./ShipService.vue?vue&type=script&lang=js"
export * from "./ShipService.vue?vue&type=script&lang=js"

import "./ShipService.vue?vue&type=style&index=0&id=78091852&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekalifront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78091852"]])

export default __exports__